/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-27 10:14:00                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-23 16:02:12                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Styles
  * FormDropdown: Collapse wrapper to avoid open state outside
*/

/* Imports */
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/solid";
import { Collapse, Typography } from "@material-tailwind/react";
import { useState } from "react";
/***/

/* Styles */
import "./FormDropdown.scss";
/***/

/**
* FormDropdown: Collapse wrapper to avoid open state outside
* @param children -  childrens node
* @param label - Collapse title
*/
export default function FormDropdown({
  children,
  label = ""
}: {
  children?: React.ReactNode,
  label: string
}) {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <div className="field-group first:border-t-0">
      <div className="field-group-collapse" onClick={() => setOpen(!open)}>
        <Typography className="text-gray-900">
          {label}
        </Typography>

        {open ? 
          <ChevronDownIcon className="w-[20px]"/>
        :
          <ChevronUpIcon className="w-[20px]"/>
        }
      </div>

      <Collapse open={open}
                className={`field-group-collapse-content ${open ? "overflow-visible" : "!overflow-hidden"}`}>
        {children}
      </Collapse>
    </div>
  );
}
/***/
